import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fmtErr } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";

export default function LoginPage() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      if (u.role === "KITCHEN") nav("/kitchen");
      else if (u.role === "STAFF") nav("/staff");
      else nav("/admin");
    } catch (err) {
      setError(fmtErr(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--surface)" }}>
      <div className="card w-full max-w-md">
        <div className="mb-6"><BrandLogo className="h-12" /></div>
        <h1 className="font-serif text-3xl mb-2">Staff Portal</h1>
        <p className="text-sm mb-6" style={{ color: "var(--muted)" }}>Sign in with your staff account.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
          {error && <div className="text-sm" style={{ color: "var(--terracotta)" }} data-testid="login-error">{error}</div>}
          <button data-testid="login-submit" type="submit" className="btn-primary w-full" disabled={busy}>{busy ? "Signing in…" : "Sign In"}</button>
        </form>
        <Link to="/owner-setup" data-testid="login-owner-setup" className="block text-center mt-4 text-sm underline" style={{ color: "var(--pine)" }}>Owner? Set or reset your password</Link>
        <Link to="/" data-testid="login-back-home" className="block text-center mt-3 text-sm" style={{ color: "var(--muted)" }}>← Back to villa website</Link>
      </div>
    </div>
  );
}
